<template>
  <v-container class="d-flex align-center group-by-btn" fluid>
    <div class="d-flex align-center">
      <v-btn
        :class="[groupBy === 'order_item' ? 'orange' : 'white', mobile ? 'custom-btn-mobile' : 'custom-btn', 'ga-farm-order_items-group-by-standard'] "
        @click="groupByHandler('order_item')"
      >{{ $t('group_by_order_item') }}</v-btn>
      <v-btn
        :class="[groupBy === 'shop' ? 'orange' : 'white', mobile ? 'custom-btn-mobile ml-2' : 'custom-btn ml-2', 'ga-farm-order_items-group-by-shop'] "
        @click="groupByHandler('shop')"
      >{{ $t('group_by_shop') }}</v-btn>
    </div>
  </v-container>
</template>

<script>

export default {
  components: {},
  props: {
    onChange: Function
  },
  data() {
    return {
      mobile: this.$vuetify.breakpoint.xs,
      groupBy: "order_item",
    };
  },
  created() {
    const { query } = this.$route;
    if (query.groupBy) this.groupBy = query.groupBy;

    this.groupByHandler(this.groupBy);
  },
  methods: {
    groupByHandler(value) {
      this.groupBy = value;
      this.onChange(value);
    }
  },
};
</script>

<style scoped>
.group-by-btn {
  overflow-x: auto;
  justify-content: flex-end;
  padding-right: 0;
}

.next {
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #cccccc;
  margin: 0 0.5rem 0 0.5rem;
}

.next-mobile {
  width: 20px;
}

.custom-btn {
  width: 140px;
}

.custom-btn-mobile {
  width: 120px;
}
</style>
